/**
 * Categorías válidas para eventos
 * Estas corresponden a los valores del ENUM categoriaEvento en la base de datos
 */
export const CATEGORIAS_EVENTO = [
  "Eventos",
  "Artistas",
  "Clubes",
  "Bares",
  "Turismo",
  "Gastronomía",
  "Hospedajes",
  "Arte y Cultura",
  "Museos",
  "Stand-up comedy",
  "Shopping",
  "Emprendimientos",
  "Deportes",
  "Bienestar",
  "Familiar",
  "Talleres"
];